import React, { ComponentType, useEffect } from 'react';
import { RouteProps } from 'react-router-dom';

import { useAuth } from '../contexts/AuthContext/AuthContext';

interface PrivateRouteProps extends RouteProps {
  component: ComponentType<any>;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ component: Component, path, ...rest }) => {
  const { isLoading, login, user } = useAuth();

  useEffect(() => {
    if (isLoading || user) {
      return;
    }
    const fn = async () => {
      await login({
        appState: { targetUrl: Array.isArray(path) ? path.join('/') : path },
      });
    };
    fn();
  }, [isLoading, user, path, login]);

  return user ? <Component {...rest} /> : null;
};

export default PrivateRoute;
